'use client';

import type { ReactNode } from 'react';
import type { CampaignId } from '@/libs/campaigns/registry';
import type { Skin } from '@/libs/campaigns/types';
import { createContext, use, useState } from 'react';
import { getSkin, resolveActiveCampaignId } from '@/libs/campaigns/registry';
import { FeatureFlag, useFeatureFlagVariant } from '@/libs/feature-flags/client';

const ActiveSkinContext = createContext<Skin | null>(null);

interface Props {
  children: ReactNode;
  /** The Active Campaign the server resolved; without one, the provider follows the live flag from the first render. */
  initialCampaignId?: CampaignId | null;
}

export function ActiveCampaignProvider({ children, initialCampaignId }: Props) {
  const liveCampaignId = resolveActiveCampaignId(useFeatureFlagVariant(FeatureFlag.CAMPAIGN_ACTIVE));
  const [campaignId, setCampaignId] = useState(initialCampaignId === undefined ? liveCampaignId : initialCampaignId);
  const [seenLiveCampaignId, setSeenLiveCampaignId] = useState(liveCampaignId);

  if (liveCampaignId !== seenLiveCampaignId) {
    setSeenLiveCampaignId(liveCampaignId);
    setCampaignId(liveCampaignId);
  }

  return <ActiveSkinContext value={getSkin(campaignId)}>{children}</ActiveSkinContext>;
}

export function useActiveSkin(): Skin | null {
  return use(ActiveSkinContext);
}
